function Utils(){
	//获取url参数
	this.getUrlParam = (paramName) => { 
	    let paramValue = "", isFound = !1; 
	    let searchQuery = decodeURI(window.location.search) || '';
	    if (searchQuery.indexOf("?") == 0 && searchQuery.indexOf("=") > 1) { 
	        let arrSource = unescape(searchQuery).substring(1, searchQuery.length).split("&"), i = 0; 
	        while (i < arrSource.length && !isFound) arrSource[i].indexOf("=") > 0 && arrSource[i].split("=")[0].toLowerCase() == paramName.toLowerCase() && (paramValue = arrSource[i].split("=")[1], isFound = !0), i++ 
	    } 
	    return paramValue == "" && (paramValue = null), decodeURI(paramValue) 
    } ;
    this.mobileCheck = (phoneNum) => {
        let regExp = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
        if(regExp.test(phoneNum)){
            return true;
        }
        return false;
    }
}

export default new Utils()


// WEBPACK FOOTER //
// ./src/utils/utils.js